import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=40c19d10&scoped=true&"
import script from "./SupportModal.vue?vue&type=script&lang=js&"
export * from "./SupportModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=40c19d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c19d10",
  null
  
)

export default component.exports